import axiosInstance from "../configs/axios";
import { route } from "ziggy-js";
import { trans } from "../i18n/i18n";

export async function addBillingAddress(data) {
    return (await axiosInstance.post(route('jsapi.user.billingAddress.add'), data)).data;
}

export async function setPrimaryBillingAddress(addressId) {
    return (await axiosInstance.post(route('jsapi.user.billingAddress.setPrimary', { id: addressId }), {
        toastMsg: trans("Failed to set billing address as default. Please try again later."),
    })).data;
}

export async function deleteBillingAddress(addressId) {
    return (await axiosInstance.delete(route('jsapi.user.billingAddress.delete', { id: addressId }), {
        toastMsg: trans("Failed to delete billing address. Please try again later."),
    })).data;
}

export async function getDefaultBillingAddress() {
    return (await axiosInstance.get(route('jsapi.user.defaultBillingAddress'), {
        toastMsg: trans("Error occured when getting Billing address."),
    })).data.address;
}

export async function getSavedAddresses() {
    return (await axiosInstance.get(route('jsapi.user.savedAddresses'), {
        skipToast: true,
    })).data;
}

export async function validateVatId({ vatId, countryCode = '', zipCode = '', isOrganization = false }) {
    return (await axiosInstance.get(route('jsapi.payment.vatData'), {
        params: {
            vatId,
            countryCode,
            zipCode,
            isOrganization,
        },
        toastMsg: trans("An error occurred while fetching the VAT rate. Please try it again later."),
    })).data;
}

export async function getCountriesWithStates() {
    return (await axiosInstance.get(route('jsapi.address.countriesWithStates'))).data.countriesWithStates;
}

export async function getStatesByCountry(countryCode) {
    return (await axiosInstance.get(route('jsapi.address.states', { a2: countryCode }), {
        toastMsg: trans("Failed to fetch states for country."),
    })).data;
}

export async function setDefaultCard(cardId) {
    return (await axiosInstance.post(route('jsapi.manageCard.setDefault', { id: cardId }), {}, {
        toastMsg: trans("Failed to set default card. Please try again later."),
    })).data;
}

export async function deleteCard(cardId) {
    return (await axiosInstance.delete(route('jsapi.manageCard.delete', { id: cardId }), {
        toastMsg: trans("Failed to remove the card. Please try again later."),
    })).data;
}

export async function getSavedCards() {
    return (await axiosInstance.get(route('jsapi.user.savedCards'), {
        skipToast: true,
    })).data;
}

export async function getCountries() {
    return (await axiosInstance.get(route('jsapi.address.countries'))).data.countries;
}
